/** Canonical finance root. In-app links use this, so the sidebar has one address. */
export const FINANCE_CANONICAL_ROOT = '/app/finances';

export const FINANCE_CLIENT_PARAM = 'client';

export const CLIENT_DASHBOARD_PATH = `${FINANCE_CANONICAL_ROOT}/overview`;

export function splitHref(href: string): { path: string; search: string } {
  const queryAt = href.indexOf('?');
  if (queryAt === -1) return { path: href, search: '' };
  return { path: href.slice(0, queryAt), search: href.slice(queryAt + 1) };
}

/** `/app/finances/` and `/app/finances` are the same surface. A bare `/` stays `/`. */
export function withoutTrailingSlash(path: string): string {
  if (path.length <= 1 || !path.endsWith('/')) return path;
  const stripped = path.replace(/\/+$/, '');
  return stripped.length > 0 ? stripped : '/';
}

export function isFinanceLogicalPath(logicalPath: string): boolean {
  const { path } = splitHref(logicalPath);
  return path === FINANCE_CANONICAL_ROOT || path.startsWith(`${FINANCE_CANONICAL_ROOT}/`);
}

export function withBookSearch(path: string, search: string, client: string | null): string {
  const params = new URLSearchParams(search);
  if (client) params.set(FINANCE_CLIENT_PARAM, client);
  else params.delete(FINANCE_CLIENT_PARAM);
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}
